import React from "react";
import { ShieldCheck } from "lucide-react";

const ConsentScreen = ({ onAccept }: { onAccept: () => void }) => {
    return (
        <div className="consent-screen">
            <div className="consent-icon">
                <ShieldCheck size={48} color="#fff" strokeWidth={1.5} />
            </div>
            <div className="consent-text">
                <h5 className="title">Terms & Conditions</h5>
                <p className="subtitle">By continuing, you agree to the following:</p>
            </div>
            <ul className="consent-list">
                <li>Your data will be processed to provide this chat service</li>
                <li>Chat conversations may be reviewed and are not guaranteed to be private</li>
            </ul>
            <div className="consent-actions">
                <button className="btn-consent-accept" onClick={onAccept}>
                    Accept & Continue
                </button>
            </div>
        </div>
    );
};

export default ConsentScreen;
